export const categoriesConstants = {
  SET_CATEGORIES_LIST_REQUEST: 'SET_CATEGORIES_LIST_REQUEST',
  SET_CATEGORIES_LIST_SUCCESS: 'SET_CATEGORIES_LIST_SUCCESS',
  SET_CATEGORIES_LIST_FAILURE: 'SET_CATEGORIES_LIST_FAILURE',
};
